export const GetTableListAPI = (search, caller) => {
  const { data, error, isLoading, isFetching } =
    search !== undefined  && search !== null ? caller(search) : caller();
  
  return {
    data,
    error,
    isLoading,
    isFetching,
  };
};
